import React, { Component } from "react";

const WeBring = () => (
  <section className="c-webring o-lettering--container">
    <div className="container">
      <div className="o-lettering o-lettering__ultra">We align</div>
      <div className="o-lettering o-lettering__thin">Technical</div>
      <div className="o-lettering o-lettering__ultra">Excellence</div>
      <div className="o-lettering o-lettering__thin">With your</div>
      <div className="o-lettering o-lettering__ultra">Business needs</div>
    </div>
  </section>
);

export default WeBring;



// WEBPACK FOOTER //
// ./src/organisms/WeBring.js